export const STORE_POKEMONS = "STORE_POKEMONS";
export const UPDATE_POKEMONS = "UPDATE_POKEMONS";
export const POKEMON_DETAILS = "POKEMON_DETAILS";
export const POKEMON_MOVE_DETAILS = "POKEMON_MOVE_DETAILS";
